import { call, put, select, takeLatest, takeLeading } from "redux-saga/effects";
import { API_URL } from "utils/constants";
import { getPaginationMeta } from "utils/helpers/pagination";
import { request } from "utils/request";

import { TireTypeForm, TireTypeListResponse } from "../types";
import {
  selectTireTypeForm,
  selectTireTypePage,
  selectTireTypePerPage,
} from "./selector";
import { tireTypeActions } from "./slice";

let isFetchingList = false;

export function* handleGetTireTypeList() {
  if (isFetchingList) return;
  isFetchingList = true;

  try {
    const page: number = yield select(selectTireTypePage);
    const perPage: number = yield select(selectTireTypePerPage);

    const response: TireTypeListResponse = yield call(
      request,
      `${API_URL}/tire-type/list?page=${page}&perPage=${perPage}`,
      { method: "GET" }
    );

    const data = response?.data || [];
    const meta = getPaginationMeta(page, perPage, data, response?.meta);
    const payload = { data, meta };

    if (page === 1) {
      yield put(tireTypeActions.getTireTypeListSuccess(payload));
    } else {
      yield put(tireTypeActions.getNextPageItemsSuccess(payload));
    }
  } catch (error) {
    const message = (error as Error).message;
    const page: number = yield select(selectTireTypePage);

    if (page === 1) {
      yield put(tireTypeActions.getTireTypeListError(message));
    } else {
      yield put(tireTypeActions.getNextPageItemsError(message));
    }
  } finally {
    isFetchingList = false;
  }
}

export function* handleAddTireType() {
  const form: TireTypeForm = yield select(selectTireTypeForm);

  try {
    yield call(request, `${API_URL}/tire-type`, {
      method: "POST",
      body: JSON.stringify({
        tireCode: form.code.trim(),
        tireTypeName: form.description.trim(),
      }),
    });

    yield put(tireTypeActions.addTireTypeSuccess());
    yield put(tireTypeActions.getTireTypeList());
  } catch (error) {
    yield put(tireTypeActions.addTireTypeError((error as Error).message));
  }
}

export function* tireTypeSaga() {
  yield takeLeading(
    [
      tireTypeActions.getTireTypeList.type,
      tireTypeActions.getNextPageItems.type,
    ],
    handleGetTireTypeList
  );
  yield takeLatest(tireTypeActions.addTireType.type, handleAddTireType);
}

export default tireTypeSaga;
